import React from 'react';
import { Box, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import PropTypes from 'prop-types';
import './Resume.css';

const Resume = () => {

    function LinearProgressWithLabel(props) {
        return (
            <Box sx={{}}>
                <Box sx={{ minWidth: 35, textAlign: 'right' }}>
                    <Typography variant="body2" color="primary.main">{`${Math.round(
                        props.value,
                    )}%`}</Typography>
                </Box>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress variant="determinate"  {...props} />
                </Box>

            </Box>
        );
    }

    LinearProgressWithLabel.propTypes = {
        /**
         * The value of the progress indicator for the determinate and buffer variants.
         * Value between 0 and 100.
         */
        value: PropTypes.number.isRequired,
    };




    function CircularProgressWithLabel(props) {
        return (
            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                <CircularProgress variant="determinate" {...props} />
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h5" fontWeight={500} component="div" color="primary.main">
                        {`${Math.round(props.value)}%`}
                    </Typography>
                </Box>
            </Box>
        );
    }

    CircularProgressWithLabel.propTypes = {
        /**
         * The value of the progress indicator for the determinate variant.
         * Value between 0 and 100.
         * @default 0
         */
        value: PropTypes.number.isRequired,
    };

    return (
        <Box sx={{ p: { xs: 2, sm: 2, md: 5 }, pb: 15, borderRadius: '10px' }} component={Paper} elevation={5}>
            <Box>
                <Typography variant='h6' sx={{ fontWeight: '700', fontSize: {xs: '18px',sm:'21px'}, color: 'primary.main' }}>Resume</Typography>
                <Typography variant='h4' sx={{ fontWeight: '700', fontSize: {xs: '25px',sm:'47px'} }}>Combination of Skill <br /> & Experience</Typography>
            </Box>
            <Box sx={{ pt: 10 }}>
                <Grid container spacing={8}>
                    <Grid item xs={12} md={6}>
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Box>
                                    <Box className='bullet'></Box>
                                </Box>
                                <Box>

                                    <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '36px' }}>Education</Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Box sx={{ display: { md: 'flex' }, justifyContent: 'space-between', alignItems: 'center', mt: 5, mb: 3 }}>
                                    <Box>
                                        <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '24px', }}>Cognitive Sciences</Typography>
                                        <Typography variant='h4' sx={{ fontWeight: '', fontSize: '20px', color: 'muted.main' }}>University of Maine</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant='h6' sx={{ fontWeight: '', color: 'primary.main', border: '1px solid #ccc', p: 1, px: 3, borderRadius: '25px' }}>2018 - 2020</Typography>
                                    </Box>
                                </Box>
                                <Typography variant='h6' sx={{ fontWeight: '300', fontSize: '18px', color: 'muted.main' }}>The goal of cognitive science is to understand the principles of intelligence with the hope that this will lead to better comprehension.</Typography>
                            </Box>
                            <Box>
                                <Box sx={{ display: { md: 'flex' }, justifyContent: 'space-between', alignItems: 'center', mt: 5, mb: 3 }}>
                                    <Box>
                                        <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '24px', }}>Cognitive Sciences</Typography>
                                        <Typography variant='h4' sx={{ fontWeight: '', fontSize: '20px', color: 'muted.main' }}>University of Maine</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant='h6' sx={{ fontWeight: '', color: 'primary.main', border: '1px solid #ccc', p: 1, px: 3, borderRadius: '25px' }}>2018 - 2020</Typography>
                                    </Box>
                                </Box>
                                <Typography variant='h6' sx={{ fontWeight: '300', fontSize: '18px', color: 'muted.main' }}>The goal of cognitive science is to understand the principles of intelligence with the hope that this will lead to better comprehension.</Typography>
                            </Box>
                        </Box>

                        <Box sx={{ pt: 8 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Box>
                                    <Box className='bullet'></Box>
                                </Box>
                                <Box>

                                    <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '36px' }}>Education</Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Box sx={{ display: { md: 'flex' }, justifyContent: 'space-between', alignItems: 'center', mt: 5, mb: 3 }}>
                                    <Box>
                                        <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '24px', }}>Cognitive Sciences</Typography>
                                        <Typography variant='h4' sx={{ fontWeight: '', fontSize: '20px', color: 'muted.main' }}>University of Maine</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant='h6' sx={{ fontWeight: '', color: 'primary.main', border: '1px solid #ccc', p: 1, px: 3, borderRadius: '25px' }}>2018 - 2020</Typography>
                                    </Box>
                                </Box>
                                <Typography variant='h6' sx={{ fontWeight: '300', fontSize: '18px', color: 'muted.main' }}>The goal of cognitive science is to understand the principles of intelligence with the hope that this will lead to better comprehension.</Typography>
                            </Box>
                            <Box>
                                <Box sx={{ display: { md: 'flex' }, justifyContent: 'space-between', alignItems: 'center', mt: 5, mb: 3 }}>
                                    <Box>
                                        <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '24px', }}>Cognitive Sciences</Typography>
                                        <Typography variant='h4' sx={{ fontWeight: '', fontSize: '20px', color: 'muted.main' }}>University of Maine</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant='h6' sx={{ fontWeight: '', color: 'primary.main', border: '1px solid #ccc', p: 1, px: 3, borderRadius: '25px' }}>2018 - 2020</Typography>
                                    </Box>
                                </Box>
                                <Typography variant='h6' sx={{ fontWeight: '300', fontSize: '18px', color: 'muted.main' }}>The goal of cognitive science is to understand the principles of intelligence with the hope that this will lead to better comprehension.</Typography>
                            </Box>
                        </Box>
                    </Grid>


                    <Grid item xs={12} md={6}>
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Box>
                                    <Box className='bullet'></Box>
                                </Box>
                                <Box>

                                    <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '36px' }}>Personal Skills</Typography>
                                </Box>
                            </Box>

                            <Box sx={{ pt: 5 }}>
                                <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '21px' }}>Time Management</Typography>
                                <LinearProgressWithLabel sx={{ borderRadius: '100%' }} value={90} />
                            </Box>
                            <Box sx={{ pt: 3 }}>
                                <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '21px' }}>Effeciency</Typography>
                                <LinearProgressWithLabel sx={{ borderRadius: '100%' }} value={70} />
                            </Box>
                            <Box sx={{ pt: 3 }}>
                                <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '21px' }}>Intigrity</Typography>
                                <LinearProgressWithLabel sx={{ borderRadius: '100%' }} value={80} />
                            </Box>
                        </Box>

                        <Box sx={{ pt: 5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Box>
                                    <Box className='bullet'></Box>
                                </Box>
                                <Box>

                                    <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '36px' }}>Software Skills</Typography>
                                </Box>
                            </Box>

                            <Box sx={{ pt: 6 }}>
                                <Grid container rowSpacing={4} columnSpacing={4}>

                                    
                                    <Grid item xs={12} sm={6} sx={{textAlign: 'center'}}>
                                        <Box>
                                            <Box sx={{ position: 'relative' }}>

                                                <CircularProgress
                                                    variant="determinate"
                                                    sx={{
                                                        color: (theme) =>
                                                            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                                                        position: 'absolute'
                                                    }}
                                                    size={200}
                                                    thickness={1}
                                                    value={100}
                                                />

                                                <CircularProgressWithLabel size={200} thickness={1} value={60} />

                                            </Box>
                                            <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '21px', mt: .5}}>UI & UX</Typography>
                                        </Box>
                                    </Grid>


                                    <Grid item xs={12} sm={6} sx={{textAlign: 'center'}}>
                                        <Box>
                                            <Box sx={{ position: 'relative' }}>

                                                <CircularProgress
                                                    variant="determinate"
                                                    sx={{
                                                        color: (theme) =>
                                                            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                                                        position: 'absolute'
                                                    }}
                                                    size={200}
                                                    thickness={1}
                                                    value={100}
                                                />

                                                <CircularProgressWithLabel size={200} thickness={1} value={70} />

                                            </Box>
                                            <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '21px', mt: .5}}>Javascript</Typography>
                                        </Box>
                                    </Grid>


                                    <Grid item xs={12} sm={6} sx={{textAlign: 'center'}}>
                                        <Box>
                                            <Box sx={{ position: 'relative' }}>

                                                <CircularProgress
                                                    variant="determinate"
                                                    sx={{
                                                        color: (theme) =>
                                                            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                                                        position: 'absolute'
                                                    }}
                                                    size={200}
                                                    thickness={1}
                                                    value={100}
                                                />

                                                <CircularProgressWithLabel size={200} thickness={1} value={80} />

                                            </Box>
                                            <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '21px', mt: .5}}>React</Typography>
                                        </Box>
                                    </Grid>


                                    <Grid item xs={12} sm={6} sx={{textAlign: 'center'}}>
                                        <Box>
                                            <Box sx={{ position: 'relative' }}>

                                                <CircularProgress
                                                    variant="determinate"
                                                    sx={{
                                                        color: (theme) =>
                                                            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                                                        position: 'absolute'
                                                    }}
                                                    size={200}
                                                    thickness={1}
                                                    value={100}
                                                />

                                                <CircularProgressWithLabel size={200} thickness={1} value={50} />

                                            </Box>
                                            <Typography variant='h4' sx={{ fontWeight: '700', fontSize: '21px', mt: .5}}>Node</Typography>
                                        </Box>
                                    </Grid>

                                   



                                </Grid>
                            </Box>


                        </Box>
                    </Grid>


                </Grid>
            </Box>
        </Box>
    );
};

export default Resume;